import React from "react"
import {
  accesDirectTitle,
  accesDirectDescription,
  accesDirectContainer,
} from "./acces-direct.module.scss"
import ContentTransformer from "../../Transformers/content-transformer"
import RenderAccesDirect from "./RenderAccesDirect/render-acces-direct"
import { useAccesDirect } from "./acces-direct-query"
//-----------------------Parent component---------------------------//

const AccesDirects = () => {
  const data = useAccesDirect()
  const accesdirectItem = data.allDirectLinkEntityDirectLinkEntity.edges
  if (accesdirectItem.length > 0) {
    return (
      <>
        <h2 className={accesDirectTitle}>
          {data.taxonomyTermTypeDeLienDirect.field_label || "Accès Direct"}
        </h2>
        {data.taxonomyTermTypeDeLienDirect.description && (
          <div className={accesDirectDescription}>
            <ContentTransformer
              content={data.taxonomyTermTypeDeLienDirect.description.processed}
            ></ContentTransformer>
          </div>
        )}
        <div className={accesDirectContainer}>
          <RenderAccesDirect accesDirectData={data} />
        </div>
      </>
    )
  }
  return null
}

//-----------------------Parent component---------------------------//

//-----------------------Prop-Types---------------------------//

//-----------------------Prop-Types---------------------------//

export default AccesDirects
